var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57806 1H5.55542C5.31912 1 5.12756 1.18216 5.12756 1.40688V12.0734C5.12756 12.2981 5.31912 12.4803 5.55542 12.4803H7.57806C7.81436 12.4803 8.00592 12.2981 8.00592 12.0734V1.40688C8.00592 1.18216 7.81436 1 7.57806 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1119 3.82797L8.61774 4.07851C8.44329 4.10776 8.32681 4.26595 8.35757 4.43184L9.81846 12.3106C9.84922 12.4765 10.0156 12.5873 10.19 12.558L11.6842 12.3075C11.8586 12.2782 11.9751 12.12 11.9443 11.9541L10.4835 4.07537C10.4527 3.90948 10.2864 3.79871 10.1119 3.82797Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58728 5.4006L9.29151 5.28247L8.58728 5.4006Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73958 2.9556L1.07529 11.8093C1.03371 12.0305 1.18857 12.2419 1.42118 12.2814L2.86135 12.5263C3.09397 12.5658 3.31625 12.4185 3.35783 12.1973L5.02212 3.3436C5.0637 3.1224 4.90884 2.91102 4.67623 2.87148L3.23605 2.62667C3.00344 2.58712 2.78116 2.73439 2.73958 2.9556Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.d059a7518e2f4bbcdb3f9b3e9af29423.svg";
export { ForwardRef as ReactComponent };